import { Row, Col, Card } from 'react-bootstrap'
import { FaPen } from "react-icons/fa"
import BootstrapSwitchButton from 'bootstrap-switch-button-react'

import CatTable from '../../../components/catalogos/CatTable';
import { COUNTRY_UPDATE } from '../../../api/Routes';
import { getActive } from '../../../utils/getActive';
import Put from '../../../api/Put';

function CountryList({items, editarPais, auth}){
    const actions = (cell, row) => <BootstrapSwitchButton
        checked={getActive(row, auth.data.company)} 
        onlabel="Activo"
        onstyle="success"
        offlabel="Inactivo"
        offstyle="danger"
        width={69}
        size="sm"
        onChange={(value)=>editarPais({...row, "active":`${value}`})
        }
    />
    const name = (cell, row) => <Row>
        <Col xs="6" sm="6" md="6" lg="6" xl="6">
            {row.name}
        </Col>
        <Col xs="6" sm="6" md="6" lg="6" xl="6" className="section-edit">
            <FaPen className='iconAction colorNaranja float-right' />
        </Col>
    </Row>
        
        const columns = [
            {
                text: 'ID',
                dataField: 'id',
                headerStyle: { width: '10%' },
            },  {
                text: 'NOMBRE',
                dataField: 'name',
                formatter: name,
                headerStyle: { width: '40%' },
                validator: (newVal, row, column) => {
                    let values = {
                        'id': row.id,
                        'name': newVal,
                        'active': row.active
                    }
                    
                    if (newVal === "") {
                        return {
                            valid: false,
                          };
                    }
    
                    if (newVal === row.name) {
                        console.log("son iguales")
                        return {
                            valid: false,
                          };
                    }
    
                    Put({url: COUNTRY_UPDATE, data: values, header:true, access_token:auth.data.access_token})
                    .then(response=>{
                        //console.log(response)
                    })    
                    return true
                }
            },  {
                dataField: '',
                isDummyField: true,
                text: 'ACCIONES',
                headerStyle: {  width: '10%', },
                formatter: actions,
                editable:false,
            }
        ]
    
        return (<>
            <Card className="shadow-1 mt-3">
                <Card.Body>
                    <CatTable 
                        columns={columns} 
                        items={items}
                    />
                </Card.Body>
            </Card>
        </>)

}

export default CountryList